<div style="display: block; height: 100%" *ngIf="type === 'pie'">
  <canvas baseChart 
    [data]="chartPieData" 
    [labels]="chartLabels" 
    [options]="chartOptions"
    [colors]="chartColors" 
    [legend]="chartLegend" 
    chartType="doughnut" >
  </canvas>
</div>

<div style="display: block; height: 100%" *ngIf="type === 'line'">
  <canvas baseChart 
    [datasets]="chartLineData" 
    [labels]="chartLabels" 
    [options]="chartOptions"
    [legend]="chartLegend" 
    chartType="line" >
  </canvas>
</div>